"use client";

import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
const menuCategories = [{
  id: 1,
  topLabel: "3-4 SEMANAS",
  title: "Fulcro Diagnóstico",
  subtitle: "Un mapa antes de construir.",
  description: "El punto de entrada. Identificamos qué procesos atacar primero, qué arquitectura tendrá efecto palanca, cuánto invertir y en qué orden.",
  linkText: "Ver Diagnóstico",
  link: "/servicios/diagnostico/",
  iconUrl: "https://solid-eft.10web.cloud/wp-content/uploads/2026/04/fulcro-icon-diagnostico.svg",
  iconAlt: "Diagnóstico"
}, {
  id: 2,
  topLabel: "IGUALA MENSUAL",
  title: "Fulcro Partner",
  subtitle: "Tu departamento fraccional de tecnología.",
  description: "El servicio principal. Construimos, integramos, automatizamos y operamos en continuo. Dos tiers según volumen: Grow y Build.",
  linkText: "Ver Partner",
  link: "/servicios/partner/",
  iconUrl: "https://solid-eft.10web.cloud/wp-content/uploads/2026/04/fulcro-icon-proceso.svg",
  iconAlt: "Proceso continuo"
}, {
  id: 3,
  topLabel: "IGUALA MENSUAL",
  title: "Fulcro Soporte",
  subtitle: "Mantenimiento profesional cuando lo grande ya se construyó.",
  description: "La operación estable. Para clientes que ya construyeron infraestructura significativa y entran en fase de operación.",
  linkText: "Ver Soporte",
  link: "/servicios/soporte/",
  iconUrl: "https://solid-eft.10web.cloud/wp-content/uploads/2026/04/fulcro-icon-tiempo.svg",
  iconAlt: "Operación continua en el tiempo"
}];
export default function QueEsFulcroYServicios() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224081" id="qué-es-fulcro" className="bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-normal mb-8 text-foreground leading-tight">
            Qué es Fulcro
          </h2>
          <div className="text-muted-foreground max-w-2xl mx-auto font-sans text-lg leading-relaxed space-y-4">
            <p>
              Fulcro es el departamento fraccional de tecnología para PyMEs que quieren escalar.
            </p>
            <p>
              Operamos como tu brazo técnico externo: diagnosticamos operaciones, diseñamos la arquitectura correcta, construimos la implementación y la mantenemos viva en el tiempo.
            </p>
            <p>
              Sin contratar un equipo de tecnología in-house.
            </p>
          </div>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {menuCategories.map((category, i) => <div key={category.id} data-index={i} className="min-h-[500px] w-full">
              <Link to={category.link} className="block w-full h-full group">
                <Card className="relative overflow-hidden w-full h-full border border-border bg-card p-0 m-0 transition-colors duration-500 group-hover:border-primary/50">
                  <CardContent className="relative h-full flex flex-col items-start justify-between p-10 bg-transparent">
                    <div className="space-y-6">
                      <div className="mb-2">
                        <img src={category.iconUrl} className="w-10 h-10 object-contain" alt={category.iconAlt} />
                      </div>

                      <span className="font-mono text-xs tracking-widest text-primary uppercase">
                        {category.topLabel}
                      </span>

                      <div className="space-y-3">
                        <h3 className="font-serif text-3xl md:text-4xl text-foreground font-normal leading-tight">
                          {category.title}
                        </h3>
                        <p className="font-sans text-base text-foreground/80 leading-relaxed">
                          {category.subtitle}
                        </p>
                      </div>

                      <p className="font-sans text-muted-foreground leading-relaxed text-base">
                        {category.description}
                      </p>
                    </div>

                    <div className="mt-8 flex items-center gap-2 text-primary font-sans font-medium group-hover:translate-x-2 transition-transform duration-300">
                      <span>{category.linkText} →</span>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}